// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';

type Props = {
    polygon: Object,
}

const PolygonAttributes = (props: Props) => {
    const { polygon } = props;

    const attributes = [
        {
            label: <FormattedMessage id="polygon-attributes-name" defaultMessage="Polygon Name" />,
            value: polygon.name,
        },
    ];

    return (
        <Attributes attributes={attributes} />
    );
};

export default PolygonAttributes;
